import { createBaseFeed } from "../../factory/core/createBaseFeed.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/theme";
import "@universityofmaryland/web-elements-library";
import "@universityofmaryland/web-elements-library/composite";
import "@universityofmaryland/web-elements-library/atomic";
import "@universityofmaryland/web-utilities-library/elements";
import { expertsDisplayStrategy } from "../../strategies/display/experts.js";
import "@universityofmaryland/web-utilities-library/network";
import "../../strategies/fetch/events.js";
import "../../strategies/fetch/news.js";
import { expertsFetchStrategy } from "../../strategies/fetch/experts.js";
import "../../strategies/fetch/inTheNews.js";
import { stackedLayout } from "../../strategies/layout/grid.js";
import "@universityofmaryland/web-elements-library/layout";
const expertsList = (props) => createBaseFeed({
  ...props,
  fetchStrategy: expertsFetchStrategy,
  displayStrategy: expertsDisplayStrategy,
  layoutStrategy: stackedLayout
});
export {
  expertsList
};
//# sourceMappingURL=list.js.map
